<div class="error-box">
    <div class="error-body text-center">
        <h1 class="error-title text-danger">999</h1>
        <h3 class="text-uppercase error-subtitle">Ya completaste la encuesta</h3>
        <p class="text-muted mt-4 mb-4">
            PARECE QUE YA HAS COMPLETADO LA ENCUENTA!
        </p>
        <p class="text-muted mt-4 mb-4">
            TE REDIRIGIREMOS A LA PÁGINA INICIAL
        </p>
        <div class="loader"></div>
    </div>
</div>